import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'vtiRouterMatcher',
  standalone: true,
})
export class RouterMatcherPipe implements PipeTransform {
  public transform(entity: string, entities: string[], mobile = false): string {
    if (entities.includes(entity)) {
      return mobile
        ? 'bg-vti-700 text-white rounded-md py-2 px-3 text-sm font-medium block'
        : 'bg-vti-700 text-white rounded-md py-2 px-3 text-sm font-medium';
    }

    return mobile
      ? 'text-white hover:bg-vti-500 hover:bg-opacity-75 rounded-md py-2 px-3 text-sm font-medium block'
      : 'text-white hover:bg-vti-500 hover:bg-opacity-75 rounded-md py-2 px-3 text-sm font-medium';
  }
}
